// ScrollToTop.js
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [searchParams,setSearchParams]=useSearchParams()
  useEffect(() => {
    console.log(searchParams.get("serviceTitle"))
    ///////&&searchParams.get("productName")===null///////////
    if(searchParams.get("serviceTitle")===null){
    window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null; // This component does not render anything
};

export default ScrollToTop;